// extracted by mini-css-extract-plugin
export default {"inputGroup":"DynamicForm_inputGroup__tElte"};